var SessionTimer = function (settings, logoutCallback, checkIfLoggedInCallback) {
  
    this.settings = settings;
    this.logoutCallback = logoutCallback;
    this.checkIfLoggedInCallback = checkIfLoggedInCallback;
  
    this.timeoutCheckIntervalSeconds = 60;
    this.warningPopupIdentifier = 'session-warning';
    this.expiredPopupIdentifier = 'session-expired';
  
    this.openedModalInstance = null;
  
    this.expiresAt;
    this.warnAt;
    this.sessionTimeoutSeconds;
    this.warnBeforeTimeoutSeconds;
  
    this.lastTimeoutCheck = 0;
    this.modalShown = false;

    this.timerTimeout = null;
  
    this.start = function () {
  
        if (this.settings && this.settings.sessionTimeoutMinutes) {
  
            this.sessionTimeoutSeconds = parseInt(this.settings.sessionTimeoutMinutes) * 60;
  
            this.warnBeforeTimeoutSeconds = 0;
            if (this.settings.warnBeforeSessionTimeoutMinutes) {
                this.warnBeforeTimeoutSeconds = parseInt(this.settings.warnBeforeSessionTimeoutMinutes) * 60;
            }

            this.shouldShowWarningModal = this.warnBeforeTimeoutSeconds > 0 && this.sessionTimeoutSeconds > this.warnBeforeTimeoutSeconds;
  
            this.recalculateTimings();
            this.timer();
        }
    }
  
    this.recalculateTimings = function () {
        var now = new Date();
        this.expiresAt = new Date(now.getTime() + this.sessionTimeoutSeconds * 1000);
        this.warnAt = new Date(this.expiresAt.getTime() - this.warnBeforeTimeoutSeconds * 1000);
    }
  
    this.onSessionExpired = function () {      
        this.onRefuseWarning();
        if(!this.checkIfLoggedInCallback()){
            clearTimeout(this.timerTimeout);
            return;
        }
        
        //do callback on session expired to execute necessary business logic
        fetch(`${this.settings.portalUrl}/api/auth/onSessionExpired`, {
            headers: { 'Content-Type': 'application/json'},
            method: 'POST',
            body: JSON.stringify({AuthToken: this.settings.authToken})
        });

        this.openedModalInstance = this.settings.modalService.showAlert(
          this.settings.sessionDynamicLabels.SessionWasTimeoutMessage, 
          () => {
            this.exitAfterSessionTimeout()
          },
          this.expiredPopupIdentifier,
          this.settings.sessionDynamicLabels.Warning,
          this.settings.sessionDynamicLabels.Reload);     
    }
  
    this.onTimeToShowWarning = function () {
        if(!this.checkIfLoggedInCallback()){
            this.onRefuseWarning();
            clearTimeout(this.timerTimeout);
        }
        
        var now = new Date();
        var seconds = Math.round((this.expiresAt - now) / 1000);
        var text = 
            `${this.settings.sessionDynamicLabels.SessionTimeoutMessage} <span id="seconds">${seconds}</span>. <br/> 
            ${this.settings.sessionDynamicLabels.MakeSureToSaveDataMessage}`; 
      
        if (!this.modalShown) {
            this.openedModalInstance = this.settings.modalService.showAlert(
              text,
              () => {
                this.continueSession();
                this.modalShown = false;
              },
              this.warningPopupIdentifier,
              this.settings.sessionDynamicLabels.Warning,
              this.settings.sessionDynamicLabels.ContinueSession);
            this.modalShown = true;
        }
        $('#seconds').html(Math.round((this.expiresAt - now) / 1000));        
    }
  
    this.onRefuseWarning = function () {
        if (this.modalShown) {
            this.openedModalInstance.close();
            this.modalShown = false;
        }
    }
  
    this.checkSessionTimeout = function (forceCheck) {
        var timePassedAfterLastCheck = (new Date() - this.lastTimeoutCheck) / 1000;
        if (forceCheck || timePassedAfterLastCheck > this.timeoutCheckIntervalSeconds) {
            var headers = { AuthToken: this.settings.authToken };
            return fetch(`${this.settings.portalUrl}/api/auth/getSessionTimeoutSeconds`, {headers: headers}).then((resp) => {
                return resp.text().then((seconds) => {
                    this.sessionTimeoutSeconds = seconds;
                    this.lastTimeoutCheck = new Date();
                    this.recalculateTimings();
                });
            });
        }
        else {
            return Promise.resolve();
        }
    }
  
    this.continueSession = function () {
        var headers = { AuthToken: this.settings.authToken };
        return fetch(`${this.settings.portalUrl}/api/auth/continueSession`, { method: 'POST', headers: headers }).then((resp) => {
            return this.checkSessionTimeout();
        });
    }
  
    this.exitAfterSessionTimeout = function () {
        setTimeout(() => {
          this.settings.modalService.closeAllModals();
          if(this.logoutCallback){
            this.logoutCallback();
          }else{
            window.location.reload(true);
          } 
        });  
    }
  
    this.timer = function () {
  
        this.timerTimeout = window.setTimeout(() => {
  
            var now = new Date();
  
            if (this.checkIfLoggedInCallback() && now >= this.expiresAt) {
                this.onRefuseWarning();

                this.checkSessionTimeout(true).then(() => {
                    now = new Date();
                    if (now >= this.expiresAt) {
                        this.onSessionExpired();
                    }
                    else {
                        this.timer();
                    }
                });
            } else if (this.checkIfLoggedInCallback() && this.shouldShowWarningModal && now >= this.warnAt && now < this.expiresAt) {
                this.checkSessionTimeout(!this.modalShown).then(() => {
                    now = new Date();
                    if (now >= this.warnAt && now < this.expiresAt) {
                        this.onTimeToShowWarning();
                        this.timer();            
                    }
                    else {
                        this.onRefuseWarning();
                        this.timer();
                    }
                });
            } else if(this.checkIfLoggedInCallback()){
                this.timer();    
            }
  
        }, 1000);
    }  
}

module.exports = SessionTimer;



// WEBPACK FOOTER //
// ./src/scripts/services/sessionTimer.js